import { fromJS } from 'immutable';
import { normalizeItems, findByIdFromIdsCollectionFn } from '@Utils';

import {
  saveAlertsType,
  removeAlertActionType,
  setRefetchType,
  setMountedType,
} from './AlertsConstants'

export const initialState = fromJS({
  refetch: false,
});

export default function alertsReducer (state = initialState, action) {
  switch(action.type) {

    case saveAlertsType: {
      const { alerts } = action.payload;
      const { items, ids } = normalizeItems(alerts);

      return state
        .set('items', fromJS(items))
        .set('ids', fromJS(ids));
    }

    case removeAlertActionType: {
      const { id } = action.payload;
      const findFn = findByIdFromIdsCollectionFn(id);

      return state
        .update('ids', (ids) => {
          const requiredIdIndex = ids.findIndex(findFn);

          return ids.delete(requiredIdIndex);
        })
        .deleteIn(['items', id]);
    }

    case setMountedType: {
      const { mounted } = action.payload;
      return state.set('mounted', mounted);
    }

    case setRefetchType: {
      const { refetch } = action.payload;
      return state.set('refetch', refetch);
    }

    default: {
      return state;
    }
  }
}
